(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/controllers/big-stat-controller.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/controllers/big-stat-controller.js');

'use strict';

svs.matchen.BigStat = function () {
  const closeBigStat = domElement => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(document.querySelector(domElement));
    });
  };

  const openBigStat = opt => {
    const searchParams = opt.searchParams && new URLSearchParams(opt.searchParams);
    const branding = svs.utils.products.getProductClassName(opt.productId);
    let matchId;
    if (opt.queryKey === 'match' && opt.queryValue) {
      matchId = parseInt(opt.queryValue, 10);
    } else {
      matchId = opt.matchId;
    }
    if (svs.core.detect.formfactor.mobile()) {
      matchId && svs.components.sportinfo.bigstat.renderBigStatModal(opt.domElement, {
        closeNavigationCallback: () => {
          Backbone.history.navigate("spela/".concat(opt.drawNumber), {
            replace: false
          });
        },
        unmountBigStatCallback: () => closeBigStat(opt.domElement)
      }, {
        appendTabSearchParams: searchParams,
        betslip: true,
        branding,
        classNameWrapper: 'big-stat',
        modulePath: opt.modulePath,
        matchId,
        productId: opt.productId,
        drawNumber: opt.drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'LIGHT'
      });
    } else {
      ReactDOM.unmountComponentAtNode(document.querySelector(opt.domElement));
      svs.components.sportinfo.bigstat.renderBigStat(opt.domElement, {
        branding,
        classNameWrapper: 'big-stat',
        modulePath: opt.modulePath,
        matchId,
        productId: opt.productId,
        drawNumber: opt.drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'DARK'
      });
    }
    const prevClickedElement = document.querySelector('.game-result-big-stat-expanded');
    if (prevClickedElement) {
      prevClickedElement.classList.remove('game-result-big-stat-expanded');
    }
    const clickedElement = document.getElementById("bigstatMatchId-".concat(opt.matchId));
    if (clickedElement) {
      clickedElement.classList.add('game-result-big-stat-expanded');
    }
  };
  return {
    closeBigStat,
    openBigStat
  };
};

 })(window);